import type { DeviceConfigLocales } from '@/types/lang/locales'
import { EDeviceConfigActions } from '../../store/deviceConfigStore/DeviceConfigStoreTypes'

export const deviceConfigEn: DeviceConfigLocales = {
    api: {
        error: {
            createDeviceConfig: 'An error occured while creating the device configuration {name}',
            deleteDeviceConfig: 'An error occured while deleting the device configuration {name}',
            fetchDeviceConfig: 'An error occured while fetching the device configuration',
            fetchDeviceConfigs: 'An error occured while fetching device configurations',
            updateDeviceConfig: 'An error occured while updating the device configuration {name}',

            createDeviceTemplateKey: 'An error occured while creating the template key {name}',
            deleteDeviceTemplateKey: 'An error occured while deleting the template key {name}',
            fetchDeviceTemplateKey: 'An error occured while fetching the template key',
            fetchDeviceTemplateKeys: 'An error occured while fetching the template keys',
            updateDeviceTemplateKey: 'An error occured while updating the template key {name}',

            fetchDeviceFirmware: 'An error occured while fetching the firmware {name}',
            fetchDeviceFirmwares: 'An error occured while fetching the firmware {name}',
            createDeviceFirmware: 'An error occured while creating the firmware {name}',
            updateDeviceFirmware: 'An error occured while updating the firmware {name}',
            deleteDeviceFirmware: 'An error occured while deleting the firmware {name}',
            exportDeviceFirmwares: 'An error occured while exporting the firmware {name}',

            [EDeviceConfigActions.CREATE_DEVICE_TYPE]:
                'An error occured while fetching the device types {name}',
            [EDeviceConfigActions.DELETE_DEVICE_TYPE]:
                'An error occured while fetching the device types {name}',
            [EDeviceConfigActions.FETCH_DEVICE_TYPE]:
                'An error occured while creating the device types {name}',
            [EDeviceConfigActions.FETCH_DEVICE_TYPES]:
                'An error occured while updating the device types {name}',
            [EDeviceConfigActions.UPDATE_DEVICE_TYPE]:
                'An error occured while deleting the device types {name}'
        },
        success: {
            createDeviceConfig: 'Device configuration {name} successfully created !',
            deleteDeviceConfig: 'Device configuration {name} successfully deleted !',
            fetchDeviceConfig: 'Device configuration successfully fetched',
            fetchDeviceConfigs: 'Device configurations successfully fetched',
            updateDeviceConfig: 'Device configuration {name} successfully updated !',

            createDeviceTemplateKey: 'Template key {name} successfully created !',
            deleteDeviceTemplateKey: 'Template key {name} successfully deleted !',
            fetchDeviceTemplateKey: 'Template key {name} successfully fetched !',
            fetchDeviceTemplateKeys: 'Template key {name} successfully fetched !',
            updateDeviceTemplateKey: 'Template key {name} successfully updated !',

            fetchDeviceFirmware: 'Firmware {name} successfully fetched !',
            fetchDeviceFirmwares: 'Firmwares successfully fetched !',
            createDeviceFirmware: 'Firmware {name} successfully created !',
            updateDeviceFirmware: 'Firmware {name} successfully updated !',
            deleteDeviceFirmware: 'Firmware {name} successfully deleted !',
            exportDeviceFirmwares: 'Firmware {name} successfully exported !',

            [EDeviceConfigActions.CREATE_DEVICE_TYPE]: 'Device type {name} successfully fetched !',
            [EDeviceConfigActions.DELETE_DEVICE_TYPE]: 'Device types successfully fetched !',
            [EDeviceConfigActions.FETCH_DEVICE_TYPE]: 'Device type {name} successfully created !',
            [EDeviceConfigActions.FETCH_DEVICE_TYPES]: 'Device type {name} successfully updated !',
            [EDeviceConfigActions.UPDATE_DEVICE_TYPE]: 'Device type {name} successfully deleted !'
        }
    },
    tabs: {
        configurations: 'Configurations',
        templateKeys: 'Configuration keys',
        types: 'Device types',
        firmwares: 'Firmwares'
    },
    firmware: {
        buttons: {
            createFirmware: 'Create a firmware',
            uploadFile: 'Upload file',
            replaceFile: 'Replace file'
        },
        model: {
            now: 'Now',
            later: 'Later',
            undefined: 'Undefined',
            name: 'Name',
            description: 'Description',
            channel: 'Channel',
            canDowngrade: 'Can downgrade',
            releaseAt: 'Release date'
        },
        title: {
            informations: 'Informations'
        },
        table: {
            channel: 'Channel',
            deviceTypeName: 'Device type',
            download: 'Download',
            name: 'Name',
            releaseAt: 'Release date'
        }
    },
    types: {
        buttons: {
            createType: 'Create device type',
            createNewType: 'Create this device type',
            updateType: 'Save modifications'
        },
        model: {
            name: 'Name'
        },
        table: {
            name: 'Name'
        },
        title: {
            informations: 'Information'
        }
    },
    template: {
        buttons: {
            createTemplate: 'Create a template',
            updateTemplate: 'Save modifications'
        },
        model: {
            deviceType: "Type d'appareil",
            version: 'N° de version'
        },
        table: {
            deviceTypeName: 'Device type',
            propertyType: 'Property type',
            version: 'Version'
        },
        title: {
            informations: 'Information',
            newKey: 'New key',
            templateKeys: 'Keys and settings'
        }
    },
    templateKeys: {
        buttons: {
            addNewExcluded: 'Add a value',
            addNewValue: 'Add a value',
            addNewPair: 'Add a pair',
            createKey: 'Create key',
            createNewKey: 'Create and add this new key',
            updateKey: 'Update key'
        },
        detail: {
            addKey: 'Add an existing key'
        },
        model: {
            category: 'Category',
            default: 'Default value',
            description: 'Description',
            excluded: 'Excluded values',
            isAdmin: 'Only for admins',
            isAdvanced: 'Advanced configuration',
            key: 'Key',
            masked: 'Show/hide field',
            range: 'Range of values',
            readOnly: 'Read only',
            translation: 'Display name',
            type: 'Type',
            unit: 'Unit',
            propertyType: 'Property type',
            values: 'Values',
            enumValues: 'Enum values',
            enumLabels: 'Associated labels'
        },
        table: {
            key: 'Key name',
            description: 'Description',
            propertyType: 'Property type',
            isAdmin: 'Admin only'
        },
        title: {
            newKey: 'New key',
            editKey: 'Edit key'
        }
    }
}
